
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/invite",
      function () {
        return require("private-next-pages/signup/invite.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/invite"])
      });
    }
  